// src/components/Footer.js
import React from "react";
import { Container, Navbar } from "react-bootstrap";

const Footer = () => {
  return (
    <Navbar bg="dark" variant="dark" className="mt-auto">
      <Container className="justify-content-center">
        <Navbar.Text>
          © {new Date().getFullYear()} My Portfolio. All rights reserved.
        </Navbar.Text>
      </Container>
    </Navbar>
  );
};

export default Footer;
